import { Tab } from 'entities/Tab/interfaces';

export const tabs: Tab[] = [
  {
    id: 'bookingData',
    href: '/manager',
    title: 'Бронювання',
  },
  {
    id: 'reportsData',
    href: '/manager/reports',
    title: 'Звіти',
  },
];
